import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { ENav } from "components/Layout/types";
import { MAP_SIDEBAR_NAV } from "components/Layout/constants";

export const useGetMainPathType = () => {
  const location = useLocation();

  const entityType = useMemo(() => {
    const splitedPaths = location.pathname.split("/");

    if (splitedPaths?.length < 3) return ENav.DASHBOARD;

    return MAP_SIDEBAR_NAV?.[splitedPaths[2]] || ENav.DASHBOARD;
  }, [location.pathname]);

  return entityType;
};
